<template>
    <div id="Console">
        <el-card shadow="never">
            <el-row>
                <el-col :span="16">
                    <el-button-group>
                        <el-button type="info" @click="refreshTypes('A')" icon="el-icon-refresh">刷新</el-button>
                        <el-button @click="affirm()" type="info">调整</el-button>
                        <!-- <el-button @click="downLoad2('调整券号')" type="success">下载表格</el-button> -->
                    </el-button-group>   
                </el-col>
                <el-col :span="6" class="serch-input" style="float:right;">
                    <el-input placeholder="请输入类型编号" v-model="input5" class="input-with-select" clearable>
                    </el-input>
                </el-col>  
            </el-row>  

            <el-row class="con-table">
                <el-col :span="24">
                    <el-table
                        v-loading="loading"
                        element-loading-text="努力加载中"
                        element-loading-spinner="el-icon-loading"
                        ref="multipleTable"
                        :data="tableData3.filter(data => !input5 || data.typeCode.includes(input5))"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange"
                        max-height="340"
                        border
                        :summary-method="getSummaries"
                        show-summary
                    >
                        <el-table-column
                            label="类型编号"
                            prop="typeCode"
                            width="120"
                            align="left"
                            header-align="center"
                        >
                        <template slot-scope="scope">{{ scope.row.typeCode }}</template>
                        </el-table-column>
                        <el-table-column
                            prop="description"
                            label="类型名称"
                            align="left"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="qty"
                            label="未销售"
                            align="right"
                            header-align="center"
                        >
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    .serch-input{
        float:right;
    }
    .select-state{
        margin-left: 10px;
    }
    .con-table{
        margin-top: 20px;
    }
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
export default {
    mixins:[requestMixin,common],
    data(){
        return {
            tableData3: [
                {
                    typeCode: '',
                    description: '',
                    qty:'',
                    //totalGeneratedQty:'',
                    creatDate: '',
                    createUser:''
                }
            ],
            multipleSelection: [],
            tableChecked:[],
            ids:[],
            value: '',
            input5:'',
            loading: false,
            amount:'',
            unAmount:'',
        }
    },
    created (){
       
    },
    mounted(){
        //如果没有Token跳转Login页面
        let Token = JSON.parse(sessionStorage.getItem('Token'));
        if(Token == undefined){
           this.$router.push({path:'/login'})
        }
        /**
         * @newCouponList 刷新列表
         */
        this.refreshTypes('A')
    },
    methods:{
        selectVal(val){
            // console.log(val)
        },

        /**
         * @handleSelectionChange(val) 选中的数组
         * @param {array} val 选中的数组
         * @returns {array} 返回选中的数组
         */
        handleSelectionChange(val) {
            this.multipleSelection = val;
            this.tableChecked = val;
        },
        //确认券
        affirm(){
            this.$router.push({
                path:'/market/adjust',
                query:{
                    confirmQty : this.unAmount 
                }
            })
        },
        downLoad2(name){
            this.isDownTable(this.tableData3, this.downLoad ,name);
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                if (index === 1) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item =>{
                    return Number(item[column.property].toString().replace(/,/g, ""))
                    
                    });
                // console.log(values)
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] = this.changeTree(sums[index]);
                } else {
                    sums[index] = '';
                }
                });
                return sums;
        },
    }
}
</script>
